import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";

export default function VerifyCardPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("t");
  const [result, setResult] = useState<{
    patronName: string;
    virtualCardNumber: string;
    status: string;
    tenantName: string;
  } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setError("No verification token provided");
      setLoading(false);
      return;
    }
    api
      .get(`/library-cards/verify?token=${encodeURIComponent(token)}`)
      .then((r) => setResult(r.data))
      .catch((e) => setError(e.response?.data?.message || "Invalid or expired card"))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md text-center">
          <h1 className="text-xl font-bold text-red-800 mb-2">Invalid Card</h1>
          <p className="text-red-700">{error}</p>
        </div>
      </div>
    );
  }

  if (result) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 max-w-md w-full">
          <h1 className="text-xl font-bold text-green-800 mb-4 flex items-center gap-2">
            <span className="text-2xl">✓</span> Valid Library Card
          </h1>
          <dl className="space-y-2">
            <div>
              <dt className="text-sm text-gray-500">Patron</dt>
              <dd className="font-semibold">{result.patronName}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Card Number</dt>
              <dd className="font-mono font-semibold">{result.virtualCardNumber}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Library</dt>
              <dd className="font-medium">{result.tenantName}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Status</dt>
              <dd className="font-medium">{result.status}</dd>
            </div>
          </dl>
        </div>
      </div>
    );
  }

  return null;
}
